export default {
  methods: {
    formatNumberWithCommas(value) {
      const numericValue = Number(value || 0);
      return numericValue.toLocaleString("en-US", {
        maximumFractionDigits: 0,
      });
    },
    formatCurrencyWithCommas(value, fractionDigits = 2) {
      const numericValue = Number(value || 0);
      return numericValue.toLocaleString("en-US", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      });
    },
    formatCurrencyDollarSign(value, fractionDigits = 2) {
      const sign = value < 0 ? "-" : "";
      const absValue = Math.abs(Number(value || 0));
      const formattedValue = absValue.toLocaleString("en-US", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      });
      return `${sign}$${formattedValue}`;
    },
  },
};
